import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Select, message, Space, Card, Typography } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../../services/api';

const { Title } = Typography;
const { Option } = Select;

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingUser, setEditingUser] = useState(null);

  // Kullanıcıları getir
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Kullanıcılar yüklenirken hata:', error);
      message.error('Kullanıcılar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // Modal'ı aç
  const showModal = (user = null) => {
    setEditingUser(user);
    if (user) {
      form.setFieldsValue({
        username: user.username,
        email: user.email,
        role: user.role,
      });
    } else {
      form.resetFields();
    }
    setModalVisible(true);
  };

  // Kullanıcı ekle/düzenle
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      if (editingUser) {
        // Kullanıcı düzenleme
        await api.put(`/users/${editingUser.id}`, values);
        message.success('Kullanıcı başarıyla güncellendi');
      } else {
        // Yeni kullanıcı ekleme
        await api.post('/users', values);
        message.success('Kullanıcı başarıyla eklendi');
      }
      setModalVisible(false);
      fetchUsers();
    } catch (error) {
      console.error('Kullanıcı işlemi hatası:', error);
      message.error('İşlem sırasında bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  // Kullanıcı silme
  const handleDelete = async (userId) => {
    Modal.confirm({
      title: 'Kullanıcıyı Sil',
      content: 'Bu kullanıcıyı silmek istediğinizden emin misiniz?',
      okText: 'Evet',
      cancelText: 'Hayır',
      onOk: async () => {
        try {
          setLoading(true);
          await api.delete(`/users/${userId}`);
          message.success('Kullanıcı başarıyla silindi');
          fetchUsers();
        } catch (error) {
          console.error('Kullanıcı silme hatası:', error);
          message.error('Kullanıcı silinirken bir hata oluştu');
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const columns = [
    {
      title: 'Kullanıcı Adı',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'E-posta',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Rol',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'İşlemler',
      key: 'actions',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => showModal(record)}
          >
            Düzenle
          </Button>
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          >
            Sil
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Title level={2}>Kullanıcı Yönetimi</Title>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => showModal()}
          >
            Yeni Kullanıcı
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={users}
          rowKey="id"
          loading={loading}
        />

        <Modal
          title={editingUser ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı'}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
        >
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
          >
            <Form.Item
              name="username"
              label="Kullanıcı Adı"
              rules={[{ required: true, message: 'Lütfen kullanıcı adı girin' }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="email"
              label="E-posta"
              rules={[
                { required: true, message: 'Lütfen e-posta girin' },
                { type: 'email', message: 'Geçerli bir e-posta adresi girin' }
              ]}
            >
              <Input />
            </Form.Item>

            {!editingUser && (
              <Form.Item
                name="password"
                label="Şifre"
                rules={[
                  { required: true, message: 'Lütfen şifre girin' },
                  { min: 6, message: 'Şifre en az 6 karakter olmalıdır' }
                ]}
              >
                <Input.Password />
              </Form.Item>
            )}

            <Form.Item
              name="role"
              label="Rol"
              rules={[{ required: true, message: 'Lütfen rol seçin' }]}
            >
              <Select>
                <Option value="admin">Admin</Option>
                <Option value="user">Kullanıcı</Option>
              </Select>
            </Form.Item>

            <Form.Item>
              <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                <Button onClick={() => setModalVisible(false)}>
                  İptal
                </Button>
                <Button type="primary" htmlType="submit" loading={loading}>
                  {editingUser ? 'Güncelle' : 'Ekle'}
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </Card>
    </div>
  );
};

export default Users; 